import { DriverWorkCycle } from "@/models/common";
import { OfficeRelatedShiftAndCycle } from "@/models/driverWorkShiftsAndCycle";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";

export const getDriverWorkCyclesPageAPI = async (
  page: number,
  size: number,
  order: any,
  officeIds?: number[]
): Promise<AxiosResponse<OfficeRelatedShiftAndCycle[]>> => {
  const sort = Object.entries(order)
    .filter(([, v]) => !!v)
    .map(([k, v]) => `${k},${v}`);

  return httpClient.get("/core/internal/calgary/driverWorkCycles/page/", {
    params: {
      officeIds,
      sort,
      page: page - (page < 1 ? 0 : 1),
      size,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getDriverWorkCyclesTotalAPI = async (
  officeIds?: number[]
): Promise<AxiosResponse<number>> => {
  return httpClient.get("/core/internal/calgary/driverWorkCycles/count/", {
    params: { officeIds },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getDriverWorkCycleAPI = async (
  driverWorkCycleId: number
): Promise<AxiosResponse<DriverWorkCycle>> => {
  return httpClient.get(
    `/core/internal/calgary/driverWorkCycles/${driverWorkCycleId}`
  );
};

export const createDriverWorkCycleAPI = async (
  request: Partial<DriverWorkCycle>
): Promise<AxiosResponse<DriverWorkCycle>> => {
  return httpClient.post(`/core/internal/calgary/driverWorkCycles/`, request);
};

export const updateDriverDailyWorkCyclesAPI = async (
  request: Partial<DriverWorkCycle>
): Promise<AxiosResponse<DriverWorkCycle>> => {
  return httpClient.put(
    `/core/internal/calgary/driverWorkCycles/${request.id}`,
    request
  );
};

export const checkEffectiveCycleAPI = async (
  cycleId: number
): Promise<AxiosResponse<boolean>> => {
  return httpClient.get(
    `/core/internal/calgary/driverWorkCycles/${cycleId}/check/`
  );
};
